import { createRouter, createWebHistory } from 'vue-router'
import Dashboard from '../pages/Dashboard.vue'
import Messages from '../pages/Messages.vue'
import ConectarInstancia from '../pages/ConectarInstancia.vue' 

const routes = [
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard
  },
  {
    path: '/messages',
    name: 'Messages',
    component: Messages
  },
  {
    path: '/conectar',
    name: 'ConectarInstancia',
    component: ConectarInstancia
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router